import "antd/dist/antd.min.css";
import "./index.css";
import "../src/sass/variables.scss";
import "../src/sass/global.scss";
import "../src/sass/utility.scss";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app/App.js";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store/index.js";
import { PersistGate } from "redux-persist/integration/react";

// Get the root element
const container = document.getElementById("root");

// Create root using React 18 API
const root = ReactDOM.createRoot(container);

// Render using modern React 18 pattern
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals())
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
